import FileUploader from 'components/UploaderAndDownloader/FileUploader';
import React, { useCallback, useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { useAdditionalValidation } from 'components/WithAdditionalValidation/useAdditionalValidation';
import { Form } from 'antd';
import { createAppError } from 'utils/helpers';
import BlobDownloader from 'components/UploaderAndDownloader/BlobDownloader';
import { postMediaFile } from 'backend/additionalInformation';
import style from './LauncherSettingsUploader.module.scss';

interface ILauncherSettingsUploader {
	setFileIdForLauncherSettings: (value: string) => void;
	launcherSettingFilePath: string | null;
	fileIdForLauncherSettings: string | null;
}

const LauncherSettingsUploader: React.FC<ILauncherSettingsUploader> = ({
	launcherSettingFilePath,
	fileIdForLauncherSettings,
	setFileIdForLauncherSettings,
}) => {
	const { addAppError, showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { isShowValidationError, validationErrorMessage } = useAdditionalValidation(
		launcherSettingFilePath || fileIdForLauncherSettings,
		'shouldUploadLauncherSettings',
		'launcherSettingsFile',
	);

	const handleSettingsUpload = useCallback(
		async (file: null | File, callback: (value: string) => void) => {
			try {
				if (file) {
					const formData = new FormData();
					formData.append('file', file, file.name);
					showLoader();
					const response = await postMediaFile({ data: formData });
					setFileIdForLauncherSettings(response.data.fileId);
					callback(file.name);
				}
			} catch (err) {
				const error = err as Error;
				const appError = createAppError(error);
				addAppError(appError);
			} finally {
				hideLoader();
			}
		},
		[setFileIdForLauncherSettings],
	);

	return (
		<Form.Item name="launcherSettingsFile">
			<div className={style.container}>
				<FileUploader
					fileType="json"
					onFileLoad={handleSettingsUpload}
					id="launcherSettingsFile"
					label="uploadSettings"
					requiredValidationMessage={isShowValidationError ? validationErrorMessage : undefined}
					filePath={launcherSettingFilePath}
				/>
				<div className={style.downloadBlock}>
					<BlobDownloader
						filePath={launcherSettingFilePath}
						fileExtension="json"
						fileName="launcher"
						label="downloadSettings"
					/>
				</div>
			</div>
		</Form.Item>
	);
};

export default React.memo(LauncherSettingsUploader);
